<template>
  <div>
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="modalPayment"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
              dark
              color="blue-grey"
              dense
              elevation="1"
              style="border-radius: 0"
            >
              <v-list-item-avatar class="mx-n2">
                <img
                  :src="
                    this.$store.getters.getAvatarClient
                      ? 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/' +
                        this.$store.getters.getAvatarClient
                      : 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/public/user.png'
                  "
                  alt=""
                />
              </v-list-item-avatar>
              <v-toolbar-title class="mx-6 body-2">{{
                getEmail
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card> </v-card>
            <v-container>
              <!--              NEW BUTTOM-->
              <opt-buton-to-pay></opt-buton-to-pay>
              <!--              END NEW BUTTON-->

              <div>
                <v-card class="text-center" height="10" elevation="0">
                  <v-card-text>
                    <!--                    <span-->
                    <!--                      class="blue-grey&#45;&#45;text text-uppercase font-weight-bold"-->
                    <!--                    >-->
                    <!--                      Seu saldo na carteira é de-->
                    <!--                      {{-->
                    <!--                        new Intl.NumberFormat("de-DE").format(getBalanceClient)-->
                    <!--                      }}-->
                    <!--                      AKz</span-->
                    <!--                    >-->
                  </v-card-text>
                  <v-card-text class="mt-n6"
                    ><span
                      class="text-uppercase m-size-font-10"
                      :class="
                        getButtonWallet ? 'green--text' : 'blue-grey--text'
                      "
                    >
                      {{ getButtonWallet ? getDisplayWallet : getDisplayMcx }}
                    </span></v-card-text
                  >
                </v-card>
              </div>
              <v-row
                class="m-center m-txt-center mx-auto"
                style="max-width: 800px"
              >
                <!--                                  <confirm-pay></confirm-pay>-->

                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="6"
                  lg="6"
                  class="mx-auto  m-center "
                >
                  <v-card class="mx-auto mt-12" width="350">
                    <v-card-text>
                      <form-pay></form-pay>
                    </v-card-text>
                  </v-card>
                  <div>
                    <v-card
                      class="d-block mt-12 mx-auto"
                      elevation="0"
                      width="350"
                    >
                      <v-card-text> </v-card-text>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<script>
import eventBus from "../../main";
import FormPay from "../../components/tools/FormPay";
// import ConfirmPay from "../../components/tools/ConfirmPay";
import OptButonToPay from "../buttons/OptButonToPay";
import { mapHelper } from "@/store/helper";
export default {
  name: "OpenWindowPayment",
  components: {
    OptButonToPay,
    "form-pay": FormPay
    // "confirm-pay": ConfirmPay
  },
  data: () => ({
    // notifications: false,
    // sound: true,
    // widgets: false,
    modalPayment: false
  }),
  methods: {
    closeModal() {
      let self = this;
      self.modalPayment = false;
      eventBus.$emit("closeConfirmPay", false); // emit the event to the bus
    }
  },
  created() {
    const self = this;
    eventBus.$on("openWpayment", function(value) {
      return (self.modalPayment = value);
    });
  },
  computed: {
    ...mapHelper
  }
};
</script>

<style scoped></style>
